// src/pages/ContactPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageBack } from '../components/shared/PageBack';

const ContactPage = () => {
  const navigate = useNavigate();
  return (
    <div style={s.page}>
      <button onClick={() => navigate(-1)} style={s.back}>
        <div style={s.backCircle}>←</div>
        <span style={s.backLbl}>Back</span>
      </button>

      <h1 style={s.h1}>Get in touch</h1>
      <p style={s.lead}>
        We're a small team and we read every message. Whatever you need, drop us a line.
      </p>

      <div style={s.card}>
        <div style={s.row}>
          <span style={s.icon}>✉️</span>
          <div>
            <div style={s.rowLabel}>Email</div>
            <a href="mailto:hello@gatheryourcommunity.com" style={s.link}>
              hello@gatheryourcommunity.com
            </a>
          </div>
        </div>
      </div>

      <div style={s.section}>
        <div style={s.sectionTitle}>Common reasons to get in touch</div>
        {[
          ['🏘️', 'Bring Gather to your town'],
          ['🤝', 'Sponsorship enquiries'],
          ['📅', 'Help posting or managing events'],
          ['🐛', 'Report a bug or issue'],
          ['💬', 'General feedback'],
        ].map(([emoji, text]) => (
          <div key={text} style={s.reason}>
            <span style={s.reasonEmoji}>{emoji}</span>
            <span style={s.reasonText}>{text}</span>
          </div>
        ))}
      </div>

      <div style={s.footer}>
        <div style={s.footerText}>Gather is built by</div>
        <div style={s.footerBrand}>Clement & Grace Limited</div>
        <div style={s.footerText}>Loughrea, Co. Galway, Ireland</div>
      </div>
      <PageBack position="bottom" fallbackPath="/profile" />
    </div>
  );
};

const s = {
  page: { background: '#fff', minHeight: '100vh', padding: '52px 24px 60px', maxWidth: 430, margin: '0 auto' },
  back: { display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', marginBottom: 24 },
  backCircle: { width: 34, height: 34, background: '#F8FBF8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, color: '#2C4A2E' },
  backLbl: { fontSize: 13, color: '#4A6A4A', fontWeight: 600 },
  h1: { fontSize: 28, fontWeight: 800, color: '#1A2E1A', marginBottom: 10, letterSpacing: '-0.3px' },
  lead: { fontSize: 15, color: '#4A6A4A', lineHeight: 1.6, marginBottom: 28, fontWeight: 500 },
  card: { background: '#F8FBF8', borderRadius: 16, padding: '20px', marginBottom: 28 },
  row: { display: 'flex', alignItems: 'center', gap: 14 },
  icon: { fontSize: 28, flexShrink: 0 },
  rowLabel: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: '#1A7A4A', marginBottom: 4 },
  link: { fontSize: 15, color: '#1A7A4A', fontWeight: 700, textDecoration: 'none' },
  section: { marginBottom: 32 },
  sectionTitle: { fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: '#1A7A4A', marginBottom: 12 },
  reason: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid #EBF2EB' },
  reasonEmoji: { fontSize: 18, flexShrink: 0 },
  reasonText: { fontSize: 14, color: '#2C4A2E', fontWeight: 600 },
  footer: { textAlign: 'center', paddingTop: 16 },
  footerText: { fontSize: 13, color: '#7A9A7A', marginBottom: 2 },
  footerBrand: { fontSize: 15, fontWeight: 700, color: '#2C4A2E', marginBottom: 2 },
};

export default ContactPage;
